import { WithdrawPointTarget } from '../enums/WithdrawPointTarget';
export const barrierStepByStepSnapshotDefaultValue = {
    [WithdrawPointTarget.GENERAL]: {
        delayed_withdraw_point: '0',
        withdraw_point: '0',
        barrier_sum: '0',
        gap: '0',
        decrease: '0',
        is_removed: false,
        target: WithdrawPointTarget.GENERAL
    }
};
//# sourceMappingURL=barrierStepByStepSnapshotDefaultValue.js.map